import { render, staticRenderFns } from "./ProductsGrid.vue?vue&type=template&id=7464c2a3"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductsGrid.vue?vue&type=style&index=0&id=7464c2a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports